const MONTHS_DE = [
  'JANUAR', 'FEBRUAR', 'MÄRZ', 'APRIL', 'MAI', 'JUNI',
  'JULI', 'AUGUST', 'SEPTEMBER', 'OKTOBER', 'NOVEMBER', 'DEZEMBER',
];

class CustomHeaderTimer extends HTMLElement {
  #interval = null;

  connectedCallback() {
    this.#updateHeadline();
    this.#startCountdown();
  }

  disconnectedCallback() {
    clearInterval(this.#interval);
    this.#interval = null;
  }

  /** Rolling end date based on settings */
  get #endDate() {
    const offset = parseInt(this.dataset.timerOffset, 10) || 1;
    const unit = this.dataset.timerUnit || 'days';
    const endHour = parseInt(this.dataset.timerEndHour, 10) ?? 22;
    const end = new Date();

    if (unit === 'hours') {
      end.setTime(end.getTime() + offset * 3600000);
    } else {
      end.setDate(end.getDate() + offset);
      end.setHours(endHour, 0, 0, 0);
    }
    return end;
  }

  /** Rolling start date based on settings */
  get #startDate() {
    const startOffset = parseInt(this.dataset.startOffset, 10) || 3;
    const start = new Date();
    start.setDate(start.getDate() - startOffset);
    return start;
  }

  #formatDay(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}`;
  }

  #updateHeadline() {
    const headline = this.querySelector('[ref="headline"]');
    if (!headline) return;

    const prefix = this.dataset.prefix || 'EINMALIGES';
    const suffix = this.dataset.suffix || 'ANGEBOT VON';
    const month = MONTHS_DE[this.#endDate.getMonth()];

    headline.textContent = `${prefix} ${month}-${suffix} ${this.#formatDay(this.#startDate)} BIS ${this.#formatDay(this.#endDate)}*`;
  }

  #startCountdown() {
    this.#tick();
    this.#interval = setInterval(() => this.#tick(), 1000);
  }

  #tick() {
    const now = new Date();
    const end = this.#endDate;
    let diff = Math.max(0, Math.floor((end - now) / 1000));

    const days = Math.floor(diff / 86400);
    diff %= 86400;
    const hours = Math.floor(diff / 3600);
    diff %= 3600;
    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;

    this.#setRef('days', days);
    this.#setRef('hours', hours);
    this.#setRef('minutes', minutes);
    this.#setRef('seconds', seconds);
  }

  #setRef(name, value) {
    const el = this.querySelector(`[ref="${name}"]`);
    if (el) el.textContent = String(value);
  }
}

customElements.define('custom-header-timer', CustomHeaderTimer);
